import { defineMessages, IntlShape } from 'react-intl';
import { InternalErrorCode } from 'fym-common/src/errors/internalErrorCodes';
import { isSocialPlatform, SocialPlatform } from './types';

/**
 * The platforms a refused post named, when music24-api refused it because a platform needs media
 * (`PromoPostNeedsMedia`, 400). The server puts them, comma-separated, in the error `details`.
 * Null for every other error, and for no error.
 */
export function promoPostNeedsMediaPlatforms(error: unknown): SocialPlatform[] | null {
  if (error === null || typeof error !== 'object') {
    return null;
  }
  const { internalCode, details } = error as { internalCode?: unknown; details?: unknown };
  if (internalCode !== InternalErrorCode.PromoPostNeedsMedia) {
    return null;
  }
  if (typeof details !== 'string') {
    return [];
  }
  return details.split(',').filter(isSocialPlatform);
}

const messages = defineMessages({
  mediaGone: {
    id: 'app.sml.promote.error.mediaGone',
    defaultMessage: 'The attached video was removed. Attach it again.',
  },
});

/**
 * The sentence for a post that the server refused because its attached file is gone
 * (`PromoPostMediaGone`, 400): a draft that waited longer than the 7 days that an unused upload
 * stays. Undefined for every other error.
 */
export function promoPostMediaGoneMessage(intl: IntlShape, error: unknown): string | undefined {
  if (error === null || typeof error !== 'object') {
    return undefined;
  }
  const cause = (error as { m24Limit?: { code?: unknown } | null }).m24Limit;
  return cause?.code === 'PromoPostMediaGone' ? intl.formatMessage(messages.mediaGone) : undefined;
}
